

















import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class PageChange extends Vue {
    @Prop() private clickEvent! : string;

    onClick(){
        this.$emit(this.clickEvent);
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
}
